<template>
  <div class='planning-ventes-wrapper'>
      <div :style='styles(vente)' :class='{ "is-cursor-pointer": isUpdate }'
        class='cell' v-for='vente in ventes' :key='vente.key'>
        <div @click='ajouterAuPanier(vente)' class="rect">
              <span v-if="vente.resteAVendre > 0 && !vente.selected">
                {{ formatageResteAVendre(vente.resteAVendre) }}
            </span>
        </div>
      </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import decorateurCasePlanning from '@/services/catalogue/planning/planningDecorateurJourNumerique';
import * as colorDispoFace from '@/configuration/colorDispoFaces';

const produitNumerique = createNamespacedHelpers('produitEcranNumerique');

export default {
  props: ['data', 'index'],
  data() {
    return {
      colorSelect: colorDispoFace.IS_SELECT,
      panierCache: null,
    };
  },
  computed: {
    ...produitNumerique.mapGetters({
      criterePlanning: 'criterePlanning',
      panier: 'panier',
      brief: 'brief',
      produitLibelle: 'produitLibelle',
      isUpdate: 'isUpdate',
    }),
    ventes() {
      const dispos = this.data.dispo.filter(d => moment(d.date).isBetween(this.criterePlanning.dateStart, this.criterePlanning.dateEnd, 'day', '[)'));
      const values = dispos.map(d => {
        const result = {};
        result.dispo = d.date;
        result.resteAVendre = d.stock - d.vendu;
        result.stock = d.stock;
        decorateurCasePlanning(result, d, this.panierCache);
        return result;
      });
      return values.length > 1 ? values : [];
    },
  },
  watch: {
    panier(newValue) {
      this.updatePanierCache(newValue, this.data.id);
    },
    data(newValue) {
      this.updatePanierCache(this.panier, newValue.id);
    },
  },
  methods: {
    ...produitNumerique.mapActions({
      updatePanier: 'updatePanier',
      actionsCalculTarifPanier: 'calculTarifPanier',
    }),
    formatageResteAVendre(resteAVendre) {
      if (resteAVendre % 1 !== 0) return resteAVendre.toFixed(2);
      return resteAVendre;
    },
    async ajouterAuPanier(vente) {
      if (!this.isUpdate) return;
      const loadingComponent = this.$buefy.loading.open();
      const splitKey = vente.key.split('|');
      const data = {
        libelleProduit: this.produitLibelle(splitKey[0]),
        produitId: splitKey[0],
        date: splitKey[1],
        typeProduit: this.$route.params.typeProduit,
        produitLocationNum: this.brief.produitLocationNum,
      };
      if (this.brief.produitLocationNum && this.brief.toggleSelectionPlanning === false) {
        this.updatePanier(data);
        vente.selected = !vente.selected;
        await this.actionsCalculTarifPanier();
      }
      loadingComponent.close();
    },
    updatePanierCache(panier, idOfProduct) {
      const newProduitPanier = panier[idOfProduct];
      if (!this.panierCache && !newProduitPanier) {
        return;
      }
      if ((!isEqual(this.panierCache, newProduitPanier) && newProduitPanier)) {
        this.panierCache = newProduitPanier;
      }
    },
    styles(vente) {
      const selectedColor = this.colorSelect;
      return `--border-color: ${vente.selected ? selectedColor : vente.stroke}; --background-color: ${vente.selected ? selectedColor : vente.fill}; --color: ${vente.textColor};`;
    },
  },
  mounted() {
    this.updatePanierCache(this.panier, this.data.id);
  },
};
</script>
